const { addDays } = require('date-fns')
const getPeriodFromProgram = require('./get-period-from-program')

module.exports = (program, period) => {
  const nextDate = addDays(new Date(period.entryEndDate), 1).toJSON()
  const next = getPeriodFromProgram(program, nextDate)
  return next
}
